import React from 'react';
import { useAuth } from 'react-oidc-context';
import { Navigate } from 'react-router-dom';
import Routes from 'shared/enums/routes';

import useRootPage from 'features/root/hooks';

const RootPage = (): React.JSX.Element => {
  const auth = useAuth();

  const { firstAuthorizedPage } = useRootPage();

  if (!auth.isAuthenticated && auth.isLoading) return <></>;

  if (auth.isAuthenticated && firstAuthorizedPage === null) {
    return <Navigate to={`${Routes.Login}?noAccess=true`} />;
  }

  return auth.isAuthenticated ? <Navigate to={firstAuthorizedPage!} /> : <Navigate to={Routes.Login} />;
};

export default RootPage;
